// extracted by mini-css-extract-plugin
export default {"patientsTableContainer":"PatientsPage_patientsTableContainer__e1oo1"};